import type { ReactNode } from 'react';

/** Строка «подпись — значение» для карточек и таблиц панели. */
export function KeyValue({
  label,
  value,
  mono = false,
}: {
  label: string;
  value: ReactNode;
  mono?: boolean;
}) {
  return (
    <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
      <span className="text-xs uppercase tracking-wide text-muted">{label}</span>
      <span className={`text-sm text-content ${mono ? 'font-mono' : ''}`}>{value}</span>
    </div>
  );
}
